import { reactive } from 'vue';

const modal = reactive({
  setting: {},
  show,
  done,
  alert,
  confirm,
  popup,
  close,
});

const defaultShowSetting = {
  isShow: true,
  hasMaskClose: false,
  hasCloseButton: true,
  header: null,
  body: null,
  footer: [],
};

function show(setting) {
  const showSetting = { ...defaultShowSetting };

  Object.entries(setting).forEach(([key, value]) => {
    showSetting[key] = value;
  });

  modal.setting = showSetting;
}

function done(message) {
  show({
    body: message,
    hasCloseButton: false,
    footer: [
      { content: '返回主畫面', type: 'primary', onClickEmit: 'toHome' },
    ],
  });
}

function alert(error) {
  const body = !error.response ? error.message : error.response.data.message;
  if (body.includes('jwt')) {
    show({
      header: '很抱歉',
      hasMaskClose: true,
      body: '目前 App 已當機，麻煩關閉 App 後重新開啟。造成您的不便，非常抱歉。',
    });
    return;
  }

  show({
    header: '提醒您',
    hasMaskClose: true,
    body,
  });
}

function confirm(message) {
  modal.show({
    body: message,
    footer: [
      {
        content: '確認',
        type: 'primary',
        onClickEmit: 'confirm',
      },
    ],
  });
}

function popup(message) {
  modal.show({
    body: message,
  });
}

function close() {
  modal.setting = {};
}

export default modal;
